import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http: HttpClient) { }
  
  getInspections (data): Observable<any> {
    return this.http.post<any>(environment.api+'inspection_report', data, httpOptions)
      .pipe(
        map(res=>res)
      );
  }
  agentActivityReport (data): Observable<any> {
    return this.http.post<any>(environment.api+'report/agent_activity', data, httpOptions)
      .pipe(
        map(res=>res)
      );
  }
  inspectorSalesReport (data): Observable<any> {
    return this.http.post<any>(environment.api+'report/inspectors_sales', data, httpOptions)
      .pipe(
        map(res=>res)
      );
  }
  agentSalesReport (data): Observable<any> {
    return this.http.post<any>(environment.api+'report/agent-sales', data, httpOptions)
      .pipe(
        map(res=>res)
      );
  }
}
